import { generateContext, useSearch, useSort } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import React, { useContext } from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'
import LazyAction from '../../../../components/helpers/LazyAction'

const { StateContext, Provider } = generateContext()
export const useLinkTreeState = () => useContext(StateContext)
export const useLinkTrees = () => useLinkTreeState().linkTrees

const QUERY = gql`
  query LinkTrees($page: Int, $sort: LinkTreeSort, $search: String, $filter: LinkTreeFilter) {
    linkTrees(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      insertedAt
      placeLevelIds
      placeTypes
      enabled
      entity
    }
  }
`

const LinkTreeLoader = ({ children, uncontrolledChildren }) => {
  const { placeType, entity } = useModalData()
  const { field, type } = useSort()
  const search = useSearch()

  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      filter: { includeDisabled: true, placeTypes: placeType, entity },
      sort: { field: field || 'NAME', type }
    },
    client: generalClient
    // fetchPolicy: 'no-cache'
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} empty={false} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default LinkTreeLoader
